import { showToast } from 'App';
import UserContext from 'Contexts/User';
import Avatars, { AvatarType, defaultAvatar } from 'assets/avatars/Avatars';
import { Logout } from 'common/models/Login';
import { useContext, useEffect, useState } from 'react';
import { NavDropdown } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, useNavigate } from 'react-router-dom';
import './header.css';
import { auth } from 'firebase';
import BackArrow from 'Components/icons/BackArrow';
import AppContext from 'Contexts/AppContext';
import styled from 'styled-components';
import { userInfo } from '../Coins/testData';

const HamburgerBut = styled.button`
 background:none;
 border:none;
 &:focus {
    outline:none;
  }
`;

export const Wrapper = styled.div`
  width:${window.screen.width > 767 ? "600px" : "100%"};
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;    
  padding: 10px;
  margin:auto;  
  margin-top: 30px;
  @media (max-width: 767px) {
    flex-wrap: nowrap;
    gap: 4px;
    padding: 6px;    
  }
`;

export const StyledButton = styled.button<{ $fullWidth?: boolean, $Active?: boolean }>`
  padding: 10px 40px;
  background: ${({ $Active }) =>
    $Active
      ? 'linear-gradient(180deg,rgb(203, 131, 255) 0%,rgb(132, 17, 255) 100%)'
      : 'linear-gradient(180deg, #6a1bbd 0%, #4b0082 100%)'};
  color: #fff;
  border: 4px solid #d1b3ff;
  border-radius: 40px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0,0,0,0.18), 0 2px 0 #2d004d;
  position: relative;
  overflow: hidden;
  transition: 0.2s;
  text-align: center;
  margin: 0 5px;

  &:hover {
    background: ${({ $Active }) =>
    $Active
      ? 'linear-gradient(180deg,rgb(203, 131, 255) 0%,rgb(132, 17, 255) 100%)'
      : 'linear-gradient(180deg, #4b0082 0%, #6a1bbd 100%)'};
    color: #fff;
  }

  // &::before {
  //   content: '';
  //   position: absolute;
  //   left: 18px;
  //   top: 14px;
  //   width: 50%;
  //   height: 30%;
  //   background: linear-gradient(120deg, rgba(255, 255, 255, 0.21) 0%, rgba(255,255,255,0.21) 100%);
  //   border-radius: 40px 40px 20px 20px;
  //   pointer-events: none;
  //   z-index: 1;
  // }

  @media (max-width: 767px) {
    padding: 6px 10px;
    font-size: 12px;
    min-width: 70px;
    width: 100px;
    max-width: 100px;
    margin: 0 2px;
  }
`;

const Header = (setMfaLogin?: any) => {
  const { userInfo, setUserInfo, setUser, user } = useContext(UserContext);
  const { setLogin, setShowMenuBar } = useContext(AppContext);
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem('userId') !== null);
  }, [localStorage.getItem('userId'), userInfo?.uid, user?.uid]);
  //   const logOutHandler = async () => {
  //     const result = await Logout(setUser);
  //     if (result) {
  //       if (window.screen.width < 767) {
  //         sessionStorage.clear();
  //       }
  //       localStorage.clear()
  //       setUserInfo();
  //       navigate('/login');
  //     } else {
  //       showToast("Unable to log out please try again.");
  //     }
  //   }
  //   const BackLogout = () => {    
  //     setLogin(true);
  //     Logout(setUser);
  //     setShowMenuBar(false)
  //     setMfaLogin(false)
  //     navigate("/")
  //     // console.log("i am working error")	
  //     localStorage.removeItem("userId")    
  // };

  const pathname = window.location.pathname;
  const PathnameArray = pathname.split("/");
  const HomeButtons = [
    { label: 'APPS', link: "/apps" },
    { label: 'BUY & GET', link: "/buyget" },
    { label: 'MY SPACE', link: `${userInfo?.uid?.includes("telegram") ? "/profile/edit" : "/profile/walletDetails"}` },
  ];

  const AfterLogoutHomeButtons = [
    { label: 'APPS', link: "/apps" },
    { label: 'BUY & GET', link: "/buyget" },
    { label: "LET'S GO", link: "/onekey" },
  ];

  // console.log(localStorage.getItem('userId') === null,"checkelocal")
  const isRootOrOneKey = pathname === '/' || pathname === '/onekey';
  const currentPathSegment = PathnameArray[1] === 'buywincard' ? 'buyget' : PathnameArray[1];
  const buttonsToRender = isLoggedIn ? HomeButtons : AfterLogoutHomeButtons;




  return (
    <header className='Header-box'>
      <div className='navColor' data-bs-theme="light" >
        {/* <div style={{paddingLeft:'0px'}}>
           {(user || userInfo?.uid) && localStorage.getItem('mfa_passed') === 'true' && <HamburgerBut
                // variant='link'
                className='position-relative'
                onClick={BackLogout}
              >
                <BackArrow />
              </HamburgerBut>
            }
      </div> */}
        <div
          className='header-container'
          style={
            window.screen.width > 767
              ? {}
              : { marginLeft: '12px', marginRight: '12px' }
          }
        >

          {/* <Navbar.Brand style={{ color: 'white', margin: 0 }}>
            <Link to={'/'} style={{ textDecoration: 'none', color: 'white' }}>
              <img src="/VTE logo.png" alt="Vote to Earn" height={50} className='me-1' />              
              Vote to Earn              
            </Link>
          </Navbar.Brand> */}


          {/* {!(pathname === '/onekey' || pathname === '/') && <Wrapper>
              {(!isLoggedIn ?AfterLogoutHomeButtons:HomeButtons)?.map((btn, index) => {
                return(
                <StyledButton {...(btn?.link.includes(PathnameArray[1]=="buywincard"?"buyget":PathnameArray[1]) && { $Active: true })} key={index} onClick={()=>{navigate(btn.link)

                }}>
                  {btn.label}
                </StyledButton>                
                )
              }                
              )}
            </Wrapper>} */}
          {!isRootOrOneKey && (
            <Wrapper>
              {buttonsToRender?.map((btn, index) => {
                const isActive = btn?.link.includes(currentPathSegment);

                return (
                  <StyledButton
                    key={index}
                    onClick={() => navigate(btn.link)}
                    {...(isActive && { $Active: true })}
                  >
                    {btn.label}
                  </StyledButton>
                );
              })}
            </Wrapper>
          )}

          {/* {(auth.currentUser && userInfo) && (
            <Navbar.Collapse className="justify-content-end" style={{ color: 'white', cursor: 'pointer' }}>

            {auth.currentUser && userInfo?.avatar!!=='skipped' && userInfo?.avatar  ?
                <Avatars
                  // @ts-ignore
                  type={userInfo?.avatar || defaultAvatar as AvatarType}
                  style={{
                    width: "45px",
                    height: "45px",
                    // border: "1px solid #6352E8",
                    // @ts-ignore                    
                  }}
                /> :
              // <span className="material-symbols-outlined d-flex align-items-center">
              //   account_circle
              // </span>
              <div style={{
                borderRadius: '100%',
                height: '50px',
                width: '50px',
                fontSize:"1.5rem",
                border: 'solid 2px white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                fontWeight: 'bold',
              }}>
                  {userInfo?.email && userInfo?.email?.length >= 0 ? userInfo?.email[0].toUpperCase() : ""}
              </div>
              }
              {(userInfo?.uid && !firstTimeLogin && !firstTimeAvatarSlection && !selectBioEdit) ?
              <NavDropdown color='white' title={window.screen.width > 767 ? userInfo?.displayName || userInfo?.email : ""}
                id="basic-nav-dropdown"
                className={`${window.screen.width > 767 ? "BigDiv" : "SmallDiv"} justify-content-start textWhite`}
                style={{ color: 'white', cursor: 'pointer' }}
              
              >
              <NavDropdown.Item  style={{ color: 'black',textAlign: 'start'}}>
                 {window.screen.width <= 767 ? userInfo?.displayName || userInfo?.email : ""}
              </NavDropdown.Item>
              <NavDropdown.Divider style={{display: window.screen.width <= 767 ? "block":"none"}} /> 
              <NavDropdown.Item className='dropdown-item' onClick={() => navigate('/')} style={{ textDecoration: 'none', color: 'black', textAlign: 'start' }}>
                Top V2E Apps
              </NavDropdown.Item>
              <NavDropdown.Item className='dropdown-item' onClick={() => navigate('/profile/edit')} style={{ textDecoration: 'none', color: 'black', textAlign: 'start' }}>
                Profile
              </NavDropdown.Item>
              <NavDropdown.Item className='dropdown-item' onClick={() => navigate('/profile/share')} style={{ textDecoration: 'none', color: 'black', textAlign: 'start' }}>
                Become Ambassador
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item style={{ textAlign: 'start' }} onClick={() => logOutHandler()}>Log out</NavDropdown.Item>
            </NavDropdown>:<span className='line-clamp-2' style={{paddingLeft:"10px"}}>{userInfo?.displayName || userInfo?.email}</span>
            }
          </Navbar.Collapse>)} */}
        </div>
      </div>
    </header >
  )
}

export default Header;